// @format
import React from 'react';
import Viewer from './Viewer';
import { Wrapper, Header, Item, Home } from './ViewerTrust';

export default () => (
  <Wrapper>
    <Header>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.PRE-RENEWAL.pdf">
        Stage 1: Pre-Renewal
      </Item>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.RENEWAL.pdf">
        Stage 2: Renewal
      </Item>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.OPEN.ENROLLMENT.pdf">
        Stage 3: Open Enrollment
      </Item>
      <Item enrollment pdf="pdf/RETA.lifecycle.enrollment.POST.ENROLLMENT.pdf">
        Stage 4: Post-Enrollment
      </Item>
      <Home />
    </Header>
    <Viewer />
  </Wrapper>
);
